import pick from 'lodash/pick';
import each from 'lodash/each';
import cloneDeep from 'lodash/cloneDeep';

class SettingsTransformer {
  transformPaymentMethod(paymentInfo, method) {
    let payload;

    switch (method) {
      case 'PAYPAL':
        payload = pick(paymentInfo, ['paypal_email']);
        break;
      case 'ACH':
        payload = {
          account_holder_name: paymentInfo.ach_details.name,
          bank_name: paymentInfo.ach_details.bank,
          account_type: paymentInfo.ach_details.type,
          account_client_type: paymentInfo.ach_details.type2,
          routing_number: paymentInfo.ach_details.routing,
          account_number: paymentInfo.ach_details.account,
        }
        break;
      case 'BANK_CHECK':
        payload = {
          name: paymentInfo.bank_check_details.name,
          address_1: paymentInfo.bank_check_details.address,
          address_2: paymentInfo.bank_check_details.apt,
          city: paymentInfo.bank_check_details.city,
          province: paymentInfo.bank_check_details.state,
          postal_code: paymentInfo.bank_check_details.pin_code,
          phone_number: paymentInfo.bank_check_details.mobile
        }
        break;
      case 'WIRE':
        payload = {
          recipient_name: paymentInfo.wire_details.recipient_name,
          address_1: paymentInfo.wire_details.recipient_address,
          address_2: paymentInfo.wire_details.recipient_apt,
          city: paymentInfo.wire_details.recipient_city,
          province: paymentInfo.wire_details.recipient_state,
          postal_code: paymentInfo.wire_details.recipient_zip,
          country: paymentInfo.wire_details.recipient_country,
          bank_name: paymentInfo.wire_details.bank_name,
          account_number: paymentInfo.wire_details.account_number,
          routing_number: paymentInfo.wire_details.bank_routing,
          account_client_type: paymentInfo.wire_details.account_type,
          bank_address_1: paymentInfo.wire_details.bank_address,
          bank_city: paymentInfo.wire_details.bank_city,
          bank_province: paymentInfo.wire_details.bank_state,
          bank_country: paymentInfo.wire_details.bank_country,
          bank_postal_code: paymentInfo.wire_details.bank_zip,
          swift_code: paymentInfo.wire_details.bank_swift_code
        }
        break;
    }

    return payload;
  }

  transformPixels(user) {
    let pixels = user.pixels,
      customVars = cloneDeep(pixels.facebook.custom_vars),
      flattenedCustomVars = [],
      payload = {};

    each(customVars, (customVarsArray, key) => {
      customVarsArray.pop();
      each(customVarsArray, customVar => flattenedCustomVars.push(customVar));
    });

    if (pixels.adroll.pixel_id) payload.adroll_pixel_id = pixels.adroll.pixel_id;
    if (pixels.adroll.adv_id) payload.adroll_advertiser_id = pixels.adroll.adv_id;
    if (pixels.custom) payload.custom_image_url = pixels.custom;
    if (pixels.facebook.id) payload.new_fb_pixel = pixels.facebook.id;
    if (flattenedCustomVars) payload.custom_fb_vars = flattenedCustomVars;
    if (pixels.google.id) payload.google_tracking_code = pixels.google.id;
    if (pixels.google.label) payload.google_retarget_code = pixels.google.label;
    if (pixels.perfect) payload.perfect_pixel_id = pixels.perfect;
    if (pixels.twitter) payload.twitter_pixel = pixels.twitter;
    if (pixels.tiktok) payload.tiktok_pixel_id = pixels.tiktok;
    if (pixels.pinterest) payload.pinterest_pixel_id = pixels.pinterest;
    if (user.google_analytics) payload.google_analytics_code = user.google_analytics;
    if (pixels.facebook.use_product_group) payload.fb_use_product_group = pixels.facebook.use_product_group;

    payload.disable_vs_retargeting = pixels.disable_vs_retargeting;

    return payload;
  }
}

export default new SettingsTransformer();